const DashboardRoutes = {
  getStats: "/admin/getstats",
  getBlogStats: "admin/getblogcounts",
}

export default DashboardRoutes;